import { render, staticRenderFns } from "./FormStoreGiftListComponent.vue?vue&type=template&id=3a5f3522&scoped=true"
import script from "./FormStoreGiftListComponent.vue?vue&type=script&lang=js"
export * from "./FormStoreGiftListComponent.vue?vue&type=script&lang=js"
import style0 from "./FormStoreGiftListComponent.vue?vue&type=style&index=0&id=3a5f3522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f3522",
  null
  
)

export default component.exports